import { createRequest, titanApi } from "./titanApi";

const statisticsApi = titanApi.enhanceEndpoints({ addTagTypes: ["statistics"] }).injectEndpoints({
  endpoints: (builder) => ({
    getUsersPerMonth: builder.query({
      query: (params) => ({
        ...createRequest(`/api/statistics/usersPerMonth`),
        method: "GET",
        params: params,
      }),
      providesTags: ["statistics"],
    }),
    getUsersPerCountry: builder.query({
      query: (params) => ({
        ...createRequest(`/api/statistics/usersPerCountry`),
        method: "GET",
        params: params,
      }),
      providesTags: ["statistics"],
    }),
    getUserRegistrationsFull: builder.query({
      query: (params) => ({
        ...createRequest(`/api/statistics/userregistrationsfull`),
        method: "GET",
        params: params,
      }),
      providesTags: ["statistics"],
    }),
    getUsersStatsFull: builder.query({
      query: (params) => ({
        ...createRequest(`/api/statistics/userstatsfull`),
        method: "GET",
        params: params,
      }),
      providesTags: ["statistics"],
    }),
    getPdfExportsFull: builder.query({
      query: (params) => ({
        ...createRequest(`/api/statistics/exportsfull`),
        method: "GET",
        params: params,
      }),
      providesTags: ["statistics"],
    }),
    getPdfExports: builder.query({
      query: (params) => ({
        ...createRequest(`/api/statistics/exports`),
        method: "GET",
        params: params,
      }),
      providesTags: ["statistics"],
    }),
    addPdfExport: builder.mutation({
      query: ({ data }) => ({
        ...createRequest("/api/statistics/exports"),
        method: "POST",
        body: { data },
      }),
      invalidatesTags: ["statistics"],
    }),
    addWordExport: builder.mutation({
      query: ({ data }) => ({
        ...createRequest("/api/statistics/wordexports"),
        method: "POST",
        body: { data },
      }),
      invalidatesTags: ["statistics"],
    }),
    getLoginsPerMonth: builder.query({
      query: (params) => ({
        ...createRequest(`/api/statistics/loginsPerMonth`),
        method: "GET",
        params: params,
      }),
      providesTags: ["statistics"],
    }),
    getGeoBimDownloads: builder.query({
      query: (params) => ({
        ...createRequest(`/api/statistics/geobimDownloads`),
        method: "GET",
        params: params,
      }),
      providesTags: ["statistics"],
    }),
    getGeoBimDownloadsFull: builder.query({
      query: (params) => ({
        ...createRequest(`/api/statistics/geobimDownloadsFull`),
        method: "GET",
        params: params,
      }),
      providesTags: ["statistics"],
    }),
    getWordExportsFull: builder.query({
      query: (params) => ({
        ...createRequest(`/api/statistics/wordexports`),
        method: "GET",
        params: params,
      }),
      providesTags: ["statistics"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUsersPerMonthQuery,
  useGetPdfExportsQuery,
  useGetPdfExportsFullQuery,
  useGetUsersPerCountryQuery,
  useAddPdfExportMutation,
  useAddWordExportMutation,
  useAddExcelExportMutation,
  useGetLoginsPerMonthQuery,
  useGetUsersStatsFullQuery,
  useGetUserRegistrationsFullQuery,
  useGetGeoBimDownloadsQuery,
  useGetGeoBimDownloadsDailyQuery,
  useGetGeoBimDownloadsFullQuery,
  useGetWordExportsFullQuery,
} = statisticsApi;
